<script setup lang="ts">
import { useColorMode } from "@vueuse/core";
import { useRouter } from "vue-router";
import { ref } from 'vue';

const mode = useColorMode();
const router = useRouter();

import { Badge } from "@/components/landingPage/ui/badge";
import { Button } from "@/components/landingPage/ui/button";
import { ArrowRight } from "lucide-vue-next";

const goToUserTypeSelection = () => {
  router.push('/commencer');
};

const email = ref('');
const interestType = ref('young_person');
const successMessage = ref('');
const submitEmail = async () => {
  try {
    const API_URL = process.env.VUE_APP_SERVER_URL || 'http://localhost:5000';
    const response = await fetch(`${API_URL}/subscribe/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email.value,
        interest_type: interestType.value,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    successMessage.value = "Votre email a bien été enregistré pour être prévenu du lancement.";
    email.value = '';
  } catch (error) {
    console.error('Subscription error:', error);
    successMessage.value = "Une erreur est survenue. Veuillez réessayer.";
  }
};
</script>

<template>
  <section class="container mx-auto">
    <div
      class="grid place-items-center lg:max-w-screen-xl gap-8 mx-auto py-20 md:py-32"
    >
      <div class="text-center space-y-8">
        <Badge
          variant="outline"
          class="text-sm py-2"
        >
          <span class="mr-2 text-white">
            <Badge>Nouveau</Badge>
          </span>
          <span> Plateforme inclusive d'orientation professionnelle </span>
        </Badge>

        <div
          class="max-w-screen-md mx-auto text-center text-5xl md:text-6xl font-bold"
        >
          <h1>
            Votre singularité est une
            <span
              class="text-transparent bg-gradient-to-r from-[#D247BF] to-[#ff9500] bg-clip-text"
              >force
            </span>
          </h1>
        </div>

        <p class="max-w-screen-sm mx-auto text-xl text-muted-foreground">
          Autrement Capable aide les personnes neurodivergentes (TSA) à découvrir leurs forces, 
          construire leur projet professionnel et s'intégrer dans le monde du travail. 
          Transformons votre singularité en opportunité.
        </p>

        <div class="space-y-4 flex flex-col items-center">
          <!--
          <Button 
            class="w-5/6 md:w-1/4 font-bold group/arrow"
            @click="goToUserTypeSelection"
          >
            Commencer
            <ArrowRight
              class="size-5 ml-2 group-hover/arrow:translate-x-1 transition-transform"
            />
          </Button>
          -->
          <!-- Nouveau formulaire d'inscription email -->
          <form @submit.prevent="submitEmail" class="flex flex-col md:flex-row items-center gap-2 w-11/12 md:w-3/4 mx-auto">
            <input
              v-model="email"
              type="email"
              required
              placeholder="Votre email"
              class="border rounded px-4 py-3 text-lg w-full"
            />
            <select
              v-model="interestType"
              class="border rounded px-4 py-3 text-lg"
            >
              <option value="young_person">Jeune</option>
              <option value="accompaneur">Accompagnateur</option>
            </select>
            <Button type="submit" class="font-bold">Être prévenu du lancement</Button>
          </form>
          <p v-if="successMessage" class="text-sm text-green-600 bg-green-50 border border-green-200 rounded px-4 py-2 w-11/12 md:w-3/4 mx-auto">
            {{ successMessage }}
          </p>
          <p class="text-xs mt-2 text-gray-500">En vous inscrivant, vous serez prévenu du lancement de la plateforme.</p>
          <Button
            as-child
            variant="secondary"
            class="w-5/6 md:w-1/4 font-bold"
          >
            <a
              href="#contact"
              >En savoir plus</a
            >
          </Button>
          <Button
            class="w-5/6 md:w-1/4 font-bold group/arrow"
            @click="goToUserTypeSelection"
          >
            Commencer
            <ArrowRight
              class="size-5 ml-2 group-hover/arrow:translate-x-1 transition-transform"
            />
          </Button>
        </div>
      </div>

      <!-- <div class="relative group mt-14">
        <div
          class="absolute -top-6 right-12 w-[90%] h-12 lg:h-[80%] bg-[#ff9500]/50 blur-3xl rounded-full img-shadow-animation"
        ></div>

        <img
          class="w-full md:w-[1200px] mx-auto rounded-lg relative rouded-lg leading-none flex items-center border border-t-2 border-t-[#ff9500]/30 img-border-animation"
          :src="
            mode == 'light' ? 'hero-image-light.jpg' : 'hero-image-dark.jpg'
          "
          alt="dashboard using shadcn-vue"
        />

        <div
          class="absolute bottom-0 left-0 w-full h-20 md:h-28 bg-gradient-to-b from-background/0 via-background/50 to-background rounded-lg"
        ></div>
      </div> -->
    </div>
  </section>
</template>

<style scoped>
.img-shadow-animation {
  animation-name: img-shadow-animation;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-direction: alternate;
}

.img-border-animation {
  animation-name: img-border-animation;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-direction: alternate;
}

@keyframes img-shadow-animation {
  from {
    opacity: 0.5;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes img-border-animation {
  from {
    border-top-color: rgba(255, 149, 0, 0.1);
  }

  to {
    border-top-color: rgba(255, 149, 0, 0.6);
  }
}
</style>
